<template>
    <div class="card p-col-12">
        <div class="exception-body notfound card" :style="{ minHeight: 100 + '%' }">
            <img src="assets/layout/images/logo-white.svg" alt="diamond-layout" class="logo" />

            <div class="exception-content">
                <div class="exception-title">Доступ ограничен</div>
                <div class="exception-detail">Посещение этой страницы не предусмотрено для Вашей роли. Если необходимо, запросите смену роли у Администратора</div>
                <router-link to="/">Вернутся на главную</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
